export default __webpack_public_path__ + "static/media/menuIcon.f8235882.svg";